export default class OpenLink {
  constructor(selector) {
    this.anchors = Array.from(document.querySelectorAll(selector))
    this.anchors.forEach(anchor => {
      anchor.setAttribute('target', '_blank')
    })
  }
}
